import React from 'react';
import Navbar from '../landing/components/Navbar';
import Hero from '../landing/components/Hero';
import LogoMarquee from '../landing/components/LogoMarquee';
import Community from '../landing/components/Community';
import Benchmarks from '../landing/components/Benchmarks';
import ApiFeatures from '../landing/components/ApiFeatures';
import EnterpriseReady from '../landing/components/EnterpriseReady';
import ProductFeatures from '../landing/components/ProductFeatures';
import Testimonials from '../landing/components/Testimonials';
import Footer from '../landing/components/Footer';

function LandingPage() {
  return (
    <main style={{ zoom: 0.85 }}>
      <Navbar />
      <Hero />
      <LogoMarquee />
      <ApiFeatures />
      <Benchmarks />
      <EnterpriseReady />
      <Testimonials />
      <ProductFeatures />
      <Community />
      <Footer />
    </main>
  );
}

export default LandingPage;
